import React from "react";
import AuthInterceptor from "../../interceptors/authInterceptor.jsx";
import Layout from "../../components/layout/AdminLayout.jsx";

function Principal(props) {
  return (
    <Layout>
      <AuthInterceptor>
        <div className="mx-20 bg-red-500 text-3xl text-white">Principal</div>;
      </AuthInterceptor>
    </Layout>
  );
}

export default Principal;
